<template>
    <template v-if="field">
        <span v-show="def.multi || !editing">
            <template v-for="(value,i) in field.value">
                <span class='value-text' v-if="value">{{value}}</span>
                <a class='value-text' v-else-if="def.user" href="#" @click.prevent="startEdit">Edit</a>
                <span v-if="def.user && editing" @click="remove(value)">&times;</span>
            </template>
            <a v-if="def.user && field.value.length==0" href="#" @click.prevent="startEdit">Edit</a>
        </span>
        <span v-if="def.user && !editing" class="edit" @click="startEdit" style="margin-left: 4px">
            <img src="/static/images/edit.png" alt="edit" />
        </span>
        <span v-if="editing">
            <input placeholder="New value" type="text" v-model="newValue" ref="input" @keydown.enter="save" @keydown.esc="cancel">
            <button @click="save">✔</button><button @click="cancel">&times;</button>
        </span>
    </template>
</template>

<script>
import i18n from '@root/components/i18n';

export default {
    props: ["field", "edit", "index"],
    emits: ["added", "removed"],
    mixins: [i18n],
    components: {},
    computed: {
        def() {
            return this.field?.def;
        },
        editing() {
            return this.def.user && (this.edit || this.localEdit);
        }
    },
    data() {
        return {
            newValue: '',
            localEdit: false,
        };
    },
    mounted() {
    },
    unmounted() {
    },
    methods: {
        startEdit() {
            this.localEdit = true;
            if (!this.def.multi) {
                this.newValue = this.field.value[0] || '';
            }
            this.$nextTick(()=>{
                this.$refs.input.focus();
            });
        },
        remove(value) {
            this.$emit("removed", { value: value, def: this.def, values: this.field });
        },
        save() {
            this.$emit("added", { value: this.newValue, def: this.def, values: this.field });
            this.newValue = '';
            this.localEdit = false;
        },
        cancel() {
            this.newValue = '';
            this.localEdit = false;
        },
    }
}
</script>

<style lang="scss">

</style>

<style lang="scss" scoped>

</style>


<i18n>
{
    en: {      
    },
    ru: {
    }
}
</i18n>
